import { useState } from "react";
import Button from "@shared/v2/Button";
import Tooltip from "@shared/v2/Tooltip";
import { ChevronRightSolidV6 } from "../../shared/v2/Icomoon";
import PropTypes from "prop-types";

const CollapsibleElement = ({
  useSecondaryColor,
  useTertiaryColor,
  title,
  buttonText,
  buttonDisabled,
  buttonDisabledTooltip,
  buttonId,
  children,
  buttonClickFunction,
  customButton,
  customButtonSchema,
  containerClassName,
  chevronPlacementLeft,
  chevronClassName,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const buttonSchema =
    customButtonSchema || (useSecondaryColor ? "warning" : useTertiaryColor ? "tertiary" : "primary");

  const renderButton = () => {
    const button = buttonText ? (
      <Button
        id={buttonId || buttonText}
        disabled={buttonDisabled}
        onClick={buttonClickFunction}
        schema={buttonSchema}
      >
        {buttonText}
      </Button>
    ) : (
      customButton
    );

    if (!button) return <span />;

    if (buttonDisabled && buttonDisabledTooltip) {
      return (
        <Tooltip
          placement="left"
          content={buttonDisabledTooltip}
          // A disabled button dispatches no mouse events; this lets the hover fall through to
          // the span Tooltip puts its listener on.
          trigger={<span className="tw-pointer-events-none">{button}</span>}
        />
      );
    }

    return button;
  };

  return (
    <div
      className={`tw-relative tw-shadow-tdp-card tw-bg-white tw-flex tw-flex-col tw-border-solid tw-border-[1px] tw-border-x-0 tw-border-t-0 tw-border-gray-10 first-of-type:tw-rounded-t-[4px] last-of-type:tw-rounded-b-[4px] ${containerClassName} `}
      {...props}
    >
      <div className="tw-flex tw-justify-between">
        <button
          className="tw-bg-transparent tw-border-none tw-p-0 tw-flex tw-items-center tw-gap-[8px]"
          onClick={() => setIsOpen((o) => !o)}
        >
          {chevronPlacementLeft ? (
            <>
              <ChevronRightSolidV6
                className={`tw-transition-all ${isOpen ? "tw-rotate-90" : ""} ${chevronClassName}`}
              />
              <span className="tw-text-18d">{title}</span>
            </>
          ) : (
            <>
              <span className="tw-text-14d">{title}</span>
              <ChevronRightSolidV6
                className={`tw-transition-all ${isOpen ? "tw-rotate-90" : ""} ${chevronClassName}`}
              />
            </>
          )}
        </button>
        {renderButton()}
      </div>
      <div
        className={`tw-transition-all tw-text-[12px] ${
          isOpen ? "tw-h-full tw-opacity-1" : "tw-h-0 tw-opacity-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

CollapsibleElement.propTypes = {
  containerClassName: PropTypes.string,
  chevronPlacementLeft: PropTypes.bool,
  chevronClassName: PropTypes.string,
  buttonDisabled: PropTypes.bool,
  buttonDisabledTooltip: PropTypes.node,
};
CollapsibleElement.defaultProps = {
  containerClassName: "tw-gap-[20px] tw-px-[20px] tw-py-[24px]",
  chevronPlacementLeft: true,
  chevronClassName: "tw-text-theme-primary",
  buttonDisabled: false,
  buttonDisabledTooltip: null,
};

export default CollapsibleElement;
